import * as React from 'react'
import {ResponsiveValue} from '@miro-site/core'
import IconBase from './IconBase'

const CheckMark: React.FC<{
  width?: ResponsiveValue<string | number>
  height?: ResponsiveValue<string | number>
  color?: string
}> = ({width = 24, height = 25, color = 'white', ...props}) => {
  return (
    <IconBase $styles={{width, height}} viewBox="0 0 24 24" {...props}>
      <path
        d="M7.70849 12.0787C7.31937 11.6768 6.6762 11.6723 6.28145 12.0687L6.20956 12.1409C5.81835 12.5337 5.82142 13.1698 6.21638 13.5589L10.0001 17.2861L17.2898 10.0442C17.6819 9.65466 17.6837 9.02084 17.2936 8.62917L17.2133 8.54855C16.8207 8.15423 16.1816 8.15633 15.7916 8.55321L10.0001 14.4458L7.70849 12.0787Z"
        fill={color}
      />
    </IconBase>
  )
}

export default CheckMark
